import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import KeyValueForm from "./KeyValuePairForm";
import useKeyValuePairForm from "./useKeyValuePairForm";
import { useEffect } from "react";

export default function KeyValueFormDialog(props) {
  const {
    onClose,
    mode,
    onAdd,
    onUpdate,
    keyValuePair,
    existingKeys,
    originalKey,
    title,
  } = props;

  const { formState, errors, updateFormState, validate } = useKeyValuePairForm(
    keyValuePair,
    existingKeys,
    originalKey,
  );

  const isModeAdd = mode === "add";

  const handlePrimary = () => {
    if (!validate()) {
      return;
    }

    if (isModeAdd) {
      onAdd(formState);
      onClose();
      return;
    }

    onUpdate(keyValuePair.key, formState);
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{isModeAdd ? `Add ${title}` : `Edit ${title}`}</DialogTitle>
      <DialogBody>
        <KeyValueForm
          formState={formState}
          errors={errors}
          updateFormState={updateFormState}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={handlePrimary}>{isModeAdd ? "Add" : "Save"}</Button>
      </DialogActions>
    </Dialog>
  );
}
